module.exports = __webpack_public_path__ + "static/media/immotech-desktop-screens.2b6c9e96.png";